import { Link } from 'react-router-dom';
import Seo, { SEO, SITE_URL } from '../components/Seo';
import JsonLd from '../components/JsonLd';
import { LIVE_TOOLS } from '../data/tools';

export default function About() {
  return (
    <>
      <Seo {...SEO.about} />
      <JsonLd
        data={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: 'About PixelUtility',
          url: `${SITE_URL}/about`,
          description: SEO.about.description,
          isPartOf: { '@id': `${SITE_URL}/#website` },
          publisher: { '@type': 'Organization', name: 'PixelUtility', url: SITE_URL },
        }}
      />
      <div className="pt-24 pb-20 px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-extrabold text-gray-900">About PixelUtility</h1>
          <div className="mt-8 space-y-5 text-gray-600 leading-relaxed text-lg">
            <p>
              PixelUtility is a content-first platform of free browser-based utilities for job seekers,
              shoppers, and small businesses. We publish detailed guides, FAQs, and blog articles on
              pixelutility.com, while each live tool runs on its own optimized subdomain.
            </p>
            <p>
              Our current live tools include an ATS-friendly resume builder, a static QR code generator,
              and an international clothing and shoe size converter. We only list tools that are fully
              functional — no “coming soon” placeholders on the public homepage.
            </p>
            <p>
              Privacy matters: tools are designed to minimize unnecessary uploads. Read our{' '}
              <Link to="/privacy" className="text-brand-600 hover:underline">Privacy Policy</Link>, contact us at{' '}
              <a href="mailto:info@pixelutility.com" className="text-brand-600 hover:underline">info@pixelutility.com</a>, or visit{' '}
              <Link to="/support" className="text-brand-600 hover:underline">Support</Link>.
            </p>
          </div>
          <h2 className="mt-12 text-2xl font-bold text-gray-900">Live Tools</h2>
          <ul className="mt-4 space-y-2">
            {LIVE_TOOLS.map((t) => (
              <li key={t.id}>
                <Link to={t.landingPath} className="text-brand-600 hover:underline">
                  {t.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
}
